import React, { useState, useEffect } from 'react';
import { Card, Select, Space, Tabs, Button } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import supplyChainService from '../../services/supplyChainService';
import api from '../../services/api';
import DataUploadTab from './components/DataUploadTab';
import AnalysisDashboardTab from './components/AnalysisDashboardTab';

const { Option } = Select;

interface UploadLog {
    id: number;
    shop_name: string;
    file_name: string;
    file_type: string;
    status: 'pending' | 'success' | 'failed';
    status_display: string;
    records_new: number;
    records_updated: number;
    created_at: string;
    error_message: string;
}

const DataCenter: React.FC = () => {
    const [shopId, setShopId] = useState<number | null>(null);
    const [shops, setShops] = useState<any[]>([]);

    // History State (Moved here to share if needed, mainly for UploadTab)
    const [history, setHistory] = useState<UploadLog[]>([]);
    const [historyLoading, setHistoryLoading] = useState(false);

    useEffect(() => {
        supplyChainService.getShops().then(res => {
            const data = res.data as any;
            setShops(Array.isArray(data) ? data : data?.results || []);
        });
        fetchHistory();
    }, []);

    const fetchHistory = async () => {
        setHistoryLoading(true);
        try {
            const res = await api.get('/data-analysis/upload-history/');
            setHistory(res.data);
        } catch (error) {
            console.error('Failed to fetch history');
        } finally {
            setHistoryLoading(false);
        }
    };

    return (
        <div style={{ padding: '12px 16px' }}>
            <Card title="数据中心" size="small" style={{ marginBottom: 16 }}>
                <Space size="large">
                    <Select placeholder="选择店铺" style={{ width: 200 }} onChange={(val) => setShopId(val)} value={shopId}>
                        {(Array.isArray(shops) ? shops : []).map(s => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                    </Select>
                </Space>
            </Card>

            <Tabs defaultActiveKey="1" items={[
                {
                    key: '1',
                    label: '数据上传',
                    children: (
                        <DataUploadTab
                            shopId={shopId}
                            history={history}
                            historyLoading={historyLoading}
                            onRefreshHistory={fetchHistory}
                        />
                    )
                },
                {
                    key: '2',
                    label: '分析仪表盘',
                    children: (
                        <AnalysisDashboardTab shopId={shopId} />
                    )
                }
            ]} />
        </div>
    );
};

export default DataCenter;
